import { render } from "./perfilEN.vue?vue&type=template&id=ad4a9c20&scoped=true"
import script from "./perfilEN.vue?vue&type=script&lang=js"
export * from "./perfilEN.vue?vue&type=script&lang=js"

import "./perfilEN.vue?vue&type=style&index=0&id=ad4a9c20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad4a9c20"]])

export default __exports__